import React from "react";
import { EmailInput } from "../../components";
import LabelledInput from "../../components/LabelledInput";
import FirstNameInput from "../../components/ValidatedFields/WithErrorLabel/FirstNameInput";
import LastNameInput from "../../components/ValidatedFields/WithErrorLabel/LastNameInput";
import { type UserInfo } from "../models";
import CulturesInterfaceDropdown from "components/dropdowns/reactselect/CulturesInterfaceDropdown";

interface Props {
  session: server.dto.ClientOnboardingSession
  userInfo: UserInfo
  onUserInfoChange: (userInfo: Partial<UserInfo>) => void
}

const UserInformation = (props: Props) => {
  const { firstName, lastName, lcid, email } = props.userInfo;

  return <div className="flex-column gap-large">
    <div>
      <LabelledInput
        required
        label={RESX.GeneralLabels.Email}
        id={"email"}
      >
        <div>
          <EmailInput
            value={email}
            validatorKey="email"
            onChange={email => { props.onUserInfoChange({ email }); }}
            emailCanBeBlank={false}
          />
        </div>
      </LabelledInput>
    </div>

    <div>
      <LabelledInput
        required
        label={RESX.Contact.FirstName}
        id="firstName"
      >
        <FirstNameInput
          onChange={newFirstName => { props.onUserInfoChange({ firstName: newFirstName }); }}
          value={firstName}
          validatorKey="firstName"
        />
      </LabelledInput>
    </div>

    <div>
      <LabelledInput
        required
        label={RESX.Contact.LastName}
        id="lastName"
      >
        <LastNameInput
          onChange={newLastName => { props.onUserInfoChange({ lastName: newLastName }); }}
          value={lastName}
          validatorKey="lastName"
        />
      </LabelledInput>
    </div>

    <div>
      <LabelledInput
        label={RESX.Language.resxLanguage}
        id="language"
        required={false}
      >
        <CulturesInterfaceDropdown
          value={serverReference.interfaceCultures.find(c => c.value === lcid)}
          onChange={c => { props.onUserInfoChange({ lcid: c.value }); }}
        />
      </LabelledInput>
    </div>
  </div>;
};

export default UserInformation;